import apiClient from './api-client';

/**
 * Realiza o login de um sistema
 */
export const sendMessage = async (messageData) => {
  try {
    const response = await apiClient.post('/chat/send', messageData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMessages = async (queryData) => {
  try {
    const response = await apiClient.get('/chat/get', { params: queryData });
    return response.data;
  } catch (error) {
    throw error;
  }
};
